module.exports = __webpack_public_path__ + "img/openstack-black.46740f63.svg";